<div class="location-container">
  <div class="address-side">
    <div class="font-bold movement-type-label">{{ TypeLabel }}</div>
    <div>
      <table style="width: 100%">
        <tr>
          <td class="icon-cell">
            <i class="fa fa-map-marker"></i>
          </td>
          <td>
            <div class="task-location">
              <div *ngIf="location?.businessName?.length > 0" class="line-1 ghost-block">
                {{ location?.businessName }}
              </div>
              <div
                class="line-2 ghost-block"
                *ngFor="
                        let item of location?.primaryAddress
                          .replace(location?.postcode, '')
                          .split(',')
                      "
              >
                {{ item }}
              </div>
              <div class="ghost-block">{{ location ? (location?.postcode | postcode) : '' }}</div>
            </div>
          </td>
        </tr>
        <tr *ngIf="location?.what3Words?.length > 0" class="what3words-row">
          <td class="icon-cell">
            <what3words-logo></what3words-logo>
          </td>
          <td>
            <div class="task-location">
              <div class="line-1 ghost-block what3words-value">{{ location?.what3Words }}</div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class="flex-grow-1 time-side">
    <div class="time-label white-space-nowrap">Earliest {{ TypeLabel }}</div>
    <div class="time-line white-space-nowrap ghost-block opacity-50" *ngIf="task?.isRescheduled">
      <i class="fa fa-calendar"></i>
      {{ originalEarliestDateTime | datex : 'ddd MMM Do' }}
      <i class="fa fa-clock-o"></i>
      {{ originalEarliestDateTime | datex : 'HH:mm' }}
    </div>
    <div class="time-line white-space-nowrap ghost-block font-bold">
      <i class="fa fa-calendar"></i>
      {{ earliestTime | datex : 'ddd MMM Do' }}
      <i class="fa fa-clock-o"></i>
      {{ earliestTime | datex : 'HH:mm' }}
    </div>
    <div class="time-label mt-3 white-space-nowrap">Latest {{ TypeLabel }}</div>
    <div class="time-line white-space-nowrap ghost-block opacity-50" *ngIf="task?.isRescheduled">
      <i class="fa fa-calendar"></i>
      {{ originalLatestDateTime | datex : 'ddd MMM Do' }}
      <i class="fa fa-clock-o"></i>
      {{ originalLatestDateTime | datex : 'HH:mm' }}
    </div>
    <div class="time-line white-space-nowrap ghost-block font-bold">
      <i class="fa fa-calendar"></i>
      {{ latestTime | datex : 'ddd MMM Do' }}
      <i class="fa fa-clock-o"></i>
      {{ latestTime | datex : 'HH:mm' }}
    </div>
  </div>
</div>
